import * as React from "react";
import { AppLayout } from "../../../layouts/app";
import { CrudLayout } from "../../../layouts/crud";
import { useContext, useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { BreadcrumbContext } from "../../../contexts/breadcrumb";
import { Link } from "react-router-dom";
import {
  Typography,
  TextField,
  Grid,
  Autocomplete,
  Button,
  IconButton,
  Switch,
  FormGroup,
  FormControlLabel,
  Stack,
} from "@mui/material";
import { VehicleForm } from "./form/index";
import { FarmForm } from "./form/index2";
import { VehiclesService } from "../../../services/vehicles";
import { DataGridVehicle } from "../../../components/dataGridVehicle";
import { TrackersService } from "../../../services/trackers";
import { SnackBar } from "../../../components/snackBar";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded';

export const Vehicles = () => {
  const initialTypeOperation = sessionStorage.getItem("typeOperationUser") || "";
  const enableSwitch = initialTypeOperation.includes("TODOS");
  const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
  const [vehicles, setVehicles] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const vehiclesService = new VehiclesService();
  const trackersService = new TrackersService();
  const [paramResponse, setParameterResponse] = useState();
  const [itemToEdit, setItemToEdit] = useState();
  const [selectedPlate, setSelectedPlate] = useState("");
  const [platesToSearch, setPlatesToSearch] = useState([]);
  const [farmsToSearch, setFarmsToSearch] = useState([]);
  const [openSnackBar, setSnackBar] = useState(false);
  const [idVehicle, setVehicleId] = useState();
  const [inputValueLabel, setInputValueLabel] = useState("Veículos");
  const [inputValueSwitch, setInputValueSwitch] = useState("vehicles");
  const [updateProcessVehiclesIsTrue, setIfUpdateProcessVehiclesIsTrue] = useState(false);
  const [listVehicleInUpdate, setListVehicleInUpdate] = useState([]);
  const TIME_FETCH_DATA_VEHICLE = 60000;

  useEffect(() => {
    const breadcrumbs = [
      <Link key="1" to="/">
        Home
      </Link>,
      <Typography key="2" color="text.primary">
        Configurações
      </Typography>,
    ];

    var result = sessionStorage.getItem("valueKanban");
    let interval;

    if (result !== null) {
      setInputValueLabel(sessionStorage.getItem("valueKanbanLabel"));
      setInputValueSwitch(result);
    }
    getVehiclesData();
    interval = setInterval(() => {
      getVehiclesData();
    }, TIME_FETCH_DATA_VEHICLE);
    setBreadcrumbs(breadcrumbs);

    return () => {
      clearInterval(interval);
    }

  }, []);

  const renderThresholdCell = (row, threshold, thresholdFormUpdate) => {
    const isAboveThreshold = thresholdFormUpdate > threshold;
    const isBelowThreshold = thresholdFormUpdate < threshold;
    if (thresholdFormUpdate == null) {
      return <Grid item>{threshold}</Grid>;
    } else if (isAboveThreshold || isBelowThreshold) {
      setIfUpdateProcessVehiclesIsTrue(true);
      if (!listVehicleInUpdate.includes(row.id)) {
        setListVehicleInUpdate((prevList) => [...prevList, row.id]);
      }

      return (
        <Grid container alignItems="center" spacing={1}>
          <Grid item>{threshold}</Grid>
          <Grid item marginTop={"4%"}>
            {<ArrowRightAltRoundedIcon fontSize="medium" />}
          </Grid>
          <Grid item>{thresholdFormUpdate}</Grid>
        </Grid>
      );
    } else {
      if (
        (row.cO2MaxThreshold !== row.cO2MaxThreshold_FormUpdate &&
          row.cO2MaxThreshold_FormUpdate != null) ||
        (row.cO2MinThreshold !== row.cO2MinThreshold_FormUpdate &&
          row.cO2MinThreshold_FormUpdate != null) ||
        (row.humidityMaxThreshold !== row.humidityMaxThreshold_FormUpdate &&
          row.humidityMaxThreshold_FormUpdate != null) ||
        (row.humidityMinThreshold !== row.humidityMinThreshold_FormUpdate &&
          row.humidityMinThreshold_FormUpdate != null) ||
        (row.temperatureMaxThreshold !==
          row.temperatureMaxThreshold_FormUpdate &&
          row.temperatureMaxThreshold_FormUpdate != null) ||
        (row.temperatureMinThreshold !==
          row.temperatureMinThreshold_FormUpdate &&
          row.temperatureMinThreshold_FormUpdate != null) ||
        (row.vibrationMaxThreshold !== row.vibrationMaxThreshold_FormUpdate &&
          row.vibrationMaxThreshold_FormUpdate != null) ||
        (row.vibrationMinThreshold !== row.vibrationMinThreshold_FormUpdate &&
          row.vibrationMinThreshold_FormUpdate != null)
      ) {
        setIfUpdateProcessVehiclesIsTrue(true);
        if (!listVehicleInUpdate.includes(row.id)) {
          setListVehicleInUpdate((prevList) => [...prevList, row.id]);
        }
      } else {
        try {
          if (listVehicleInUpdate.includes(row.id)) {
            const index = listVehicleInUpdate.indexOf(row.id);
            if (index > -1) {
              listVehicleInUpdate.splice(index, 1);
            }
            setListVehicleInUpdate(listVehicleInUpdate);
          }
        } catch (error) {
          console.error(error);
        }
        setIfUpdateProcessVehiclesIsTrue(false);
      }
      return <Grid item>{thresholdFormUpdate}</Grid>;
    }
  };

  const columns = [
    {
      field: "plate",
      headerName: (
        <Typography variant="subtitle1" component="div" align="center">
          Placa
        </Typography>
      ),
      width: 170,
      editable: false,
    },
    {
      field: "model",
      headerName: (
        <Typography variant="subtitle1" align="center">
          Modelo
        </Typography>
      ),
      width: 170,
      editable: false,
    },
    {
      field: "temperatureMinThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Temp.
          <br />
          Limiar Inf.
        </Typography>
      ),

      width: 125,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.temperatureMinThreshold,
          row.temperatureMinThreshold_FormUpdate
        ),
    },
    {
      field: "temperatureMaxThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Temp.
          <br />
          Limiar Sup.
        </Typography>
      ),
      width: 125,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.temperatureMaxThreshold,
          row.temperatureMaxThreshold_FormUpdate
        ),
    },
    {
      field: "humidityMinThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Umid.
          <br />
          Limiar Inf.
        </Typography>
      ),
      width: 125,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.humidityMinThreshold,
          row.humidityMinThreshold_FormUpdate
        ),
    },
    {
      field: "humidityMaxThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Umid.
          <br />
          Limiar Sup.
        </Typography>
      ),
      width: 125,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.humidityMaxThreshold,
          row.humidityMaxThreshold_FormUpdate
        ),
    },
    {
      field: "cO2MinThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          CO2
          <br />
          Limiar Inf.
        </Typography>
      ),
      width: 125,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.cO2MinThreshold,
          row.cO2MinThreshold_FormUpdate
        ),
    },
    {
      field: "cO2MaxThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          CO2
          <br />
          Limiar Sup.
        </Typography>
      ),
      width: 125,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.cO2MaxThreshold,
          row.cO2MaxThreshold_FormUpdate
        ),
    },
    {
      field: "vibrationMinThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Vibr.
          <br />
          Limiar Inf.
        </Typography>
      ),
      width: 118,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.vibrationMinThreshold,
          row.vibrationMinThreshold_FormUpdate
        ),
    },
    {
      field: "vibrationMaxThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Vibr.
          <br />
          Limiar Sup.
        </Typography>
      ),
      width: 118,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.vibrationMaxThreshold,
          row.vibrationMaxThreshold_FormUpdate
        ),
    },
  ];

  const columnsFarm = [
    {
      field: "plate",
      headerName: (
        <Typography variant="subtitle1" component="div" align="center">
          Granja
        </Typography>
      ),
      width: 200,
      editable: false,
    },
    {
      field: "model",
      headerName: (
        <Typography variant="subtitle1" align="center">
          Sala
        </Typography>
      ),
      width: 200,
      editable: false,
    },
    {
      field: "temperatureMinThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Temp.
          <br />
          Limiar Inf.
        </Typography>
      ),

      width: 110,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.temperatureMinThreshold,
          row.temperatureMinThreshold_FormUpdate
        ),
    },
    {
      field: "temperatureMaxThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Temp.
          <br />
          Limiar Sup.
        </Typography>
      ),
      width: 110,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.temperatureMaxThreshold,
          row.temperatureMaxThreshold_FormUpdate
        ),
    },
    {
      field: "humidityMinThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Umid.
          <br />
          Limiar Inf.
        </Typography>
      ),
      width: 110,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.humidityMinThreshold,
          row.humidityMinThreshold_FormUpdate
        ),
    },
    {
      field: "humidityMaxThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          Umid.
          <br />
          Limiar Sup.
        </Typography>
      ),
      width: 110,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.humidityMaxThreshold,
          row.humidityMaxThreshold_FormUpdate
        ),
    },
    {
      field: "cO2MinThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          CO2
          <br />
          Limiar Inf.
        </Typography>
      ),
      width: 140,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.cO2MinThreshold,
          row.cO2MinThreshold_FormUpdate
        ),
    },
    {
      field: "cO2MaxThreshold",
      headerName: (
        <Typography variant="subtitle2" component="div" align="center">
          CO2
          <br />
          Limiar Sup.
        </Typography>
      ),
      width: 140,
      editable: false,
      renderCell: ({ row }) =>
        renderThresholdCell(
          row,
          row.cO2MaxThreshold,
          row.cO2MaxThreshold_FormUpdate
        ),
    },
  ];

  const getVehiclesData = () => {
    let plates = [];
    let farms = [];
    setItemToEdit();
    vehiclesService
      .getVehicles()
      .then((res) => {
        const responseData = res.data;
        try {
          responseData.forEach((item) => {
            if (
              initialTypeOperation.includes(item.typeOperation) ||
              (initialTypeOperation.includes("TODOS") &&
                item.typeOperation === "OVOS") ||
              (initialTypeOperation.includes(item.typeOperation) &&
                item.typeOperation === "PINTOS") ||
              (initialTypeOperation.includes("TODOS") &&
                item.typeOperation === "EMBRIÕES")
            ) {
              plates.push(item.plate);
            } else if (
              initialTypeOperation.includes(item.typeOperation) ||
              (initialTypeOperation.includes("TODOS") &&
                item.typeOperation === "SALA1") ||
              (initialTypeOperation.includes("TODOS") &&
                item.typeOperation === "SALA2") ||
              (initialTypeOperation.includes("TODOS") &&
                item.typeOperation === "SALA3") ||
              (initialTypeOperation.includes("TODOS") &&
                item.typeOperation === "SALA4")
            ) {
              farms.push(item.plate);
            } else {
              plates.push(item.plate);
              farms.push(item.plate);
            }
          });
        } catch (error) {
          console.error(error);
        }

        setPlatesToSearch(plates);
        setFarmsToSearch(farms);
        // let promises = [];
        // responseData.map((item) => {
        //   let promise = getResponseParam(item.id);
        //   promises.push(promise);
        // });
        // Promise.all(promises).then(value => {
        // }).catch(error => {
        //   console.error(error);
        // })

        setVehicles(res.data);
        setLoadingData(false);
      })
      .catch((err) => {
        setLoadingData(false);
      });
  };

  const getResponseParam = (trackerID) => {
    return trackersService
      .getResponseParam(trackerID)
      .then((response) => {
        const status = response.data.status;
        if (status === 0) {
          setParameterResponse(0);
        } else if (status === 2) {
          setParameterResponse(2);
        } else {
          setParameterResponse(6);
        }
        return status
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  };

  const handleUpdate = (updatedVehicle) => {
    vehiclesService
      .updateVehicle(updatedVehicle)
      .then((res) => {
        if (res.status === 200) {
          NotificationManager.success("Registro atualizado com sucesso.", "", 3000);
          getVehiclesData();
        }
      })
      .catch((err) => {
        NotificationManager.error("Erro ao atualizar registro", "", 3000);
      });
  };

  const handleDelete = (id) => {
    vehiclesService
      .deleteVehicle(id)
      .then((res) => {
        if (res.status === 200) {
          NotificationManager.success("Registro removido.");
          setVehicleId(id);
          getVehiclesData();
          setSnackBar(true);
        }
      })
      .catch((err) => {
        NotificationManager.error("Erro ao remover registro");
      });
  };

  const handleCloseSnackBar = () => {
    setSnackBar(false);
  };

  const handleUndoOperation = () => {
    vehiclesService
      .undoVehicle(idVehicle)
      .then((res) => {
        getVehiclesData();
        setSnackBar(false);
      })
      .catch((error) => {
      });
  };

  const handleOpenModal = (item) => {
    setItemToEdit(item);
  };

  const handlePlateSearch = (evt, value, reason, details) => {
    if (value === undefined || value === null) setSelectedPlate("");
    else setSelectedPlate(value);
  };

  const handleChangeSwitch = (evt, value) => {
    if (value === false) {
      setInputValueSwitch("farms");
      setInputValueLabel("Granjas");
      sessionStorage.setItem("valueKanbanLabel", "Granjas");
      sessionStorage.setItem("valueKanban", "farms");
    } else if (value === true) {
      setInputValueSwitch("vehicles");
      setInputValueLabel("Veículos");
      sessionStorage.setItem("valueKanbanLabel", "Veículos");
      sessionStorage.setItem("valueKanban", "vehicles");
    }
  };

  const handleSetItemToEdit = () => {
    setItemToEdit();
  }

  const lockVehicle = () => { };
  const unlockVehicle = () => { };

  const action = (
    <React.Fragment>
      <Button color="success" size="small" onClick={handleUndoOperation}>
        DESFAZER
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnackBar}
      >
        <CloseRoundedIcon fontSize="small" sx={{ color: "black" }} />
      </IconButton>
    </React.Fragment>
  );

  return (
    <>
      {(initialTypeOperation.includes("OVOS") ||
        initialTypeOperation.includes("PINTOS") ||
        initialTypeOperation.includes("EMBRIÕES") ||
        initialTypeOperation.includes("TODOS")) &&
        (inputValueSwitch === "vehicles") ? (
        <AppLayout>
          <Grid container display={'flex'} flexDirection={'column'}>
            {enableSwitch ? (
              <Grid item xl={2} md={3} sm={4} xs={6}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Stack direction="row" sx={{ alignItems: 'center', marginLeft: '10px' }}>
                        <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Granjas</Typography>
                        <Switch
                          sx={{
                            height: "45px",
                            width: "70px",
                            "& .MuiSwitch-switchBase": {
                              margin: 0,
                              padding: 1,
                              transform: "translateX(2px)",
                              "&.Mui-checked": {
                                color: "#fff",
                                transform: "translateX(30px)",
                                "& .MuiSwitch-thumb:before": {},
                                "& + .MuiSwitch-track": {
                                  opacity: 1,
                                  backgroundColor: "#5c7fb8",
                                },
                              },
                            },
                            "& .MuiSwitch-thumb": {
                              backgroundColor: "#21519f",
                              width: 28,
                              height: 28,
                              "&:before": {
                                content: "''",
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                left: 1,
                                top: 0,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                              },
                            },
                            "& .MuiSwitch-track": {
                              opacity: 1,
                              backgroundColor: "#5c7fb8",
                              borderRadius: 20 / 2,
                            },
                          }}
                          checked={true}
                          onChange={handleChangeSwitch}
                        />
                        <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Veículos</Typography>
                      </Stack>
                    }
                    sx={{ width: "80px" }}
                  />
                </FormGroup>
              </Grid>
            ) : (
              <></>
            )}

            <Grid item xl={3} md={3} sm={4} xs={6}>
              <Autocomplete
                id="combo-plates"
                options={platesToSearch}
                sx={{
                  width: "100%",
                  marginBottom: "-50px",
                }}
                size="small"
                onChange={handlePlateSearch}
                renderInput={(params) => (
                  <TextField {...params} label="Pesquisar Veículos" />
                )}
              />
            </Grid>
            <Grid item>
              <CrudLayout
                title={<></>}
                formTitle="Cadastro Veículo"
                form={<VehicleForm />}
                itemToEdit={itemToEdit}
                cleanItemToEdit={handleSetItemToEdit}
                hasNewButton
                onModalClosed={getVehiclesData}
                modalHeight={750}
                children={
                  <DataGridVehicle
                    columns={columns}
                    editMode="row"
                    data={vehicles.filter((vehicle) => {
                      if (
                        vehicle.typeOperation === "OVOS" ||
                        vehicle.typeOperation === "PINTOS" ||
                        vehicle.typeOperation === "EMBRIÕES" ||
                        vehicle.typeOperation === ""
                      ) {
                        return vehicle.plate.includes(selectedPlate);
                      }
                    })}
                    form={<VehicleForm />}
                    handleOpenModal={handleOpenModal}
                    onEditOpenModal={true}
                    loadingData={loadingData}
                    updateRecord={handleUpdate}
                    deleteRecord={handleDelete}
                    lockVehicle={lockVehicle}
                    unlockVehicle={unlockVehicle}
                    sendOrNot={paramResponse}
                    type={"vehicle"}
                    updateProcessVehiclesIsTrue={updateProcessVehiclesIsTrue}
                    listVehicleInUpdate={listVehicleInUpdate}
                  />
                }
              />
            </Grid>
            <Grid item>
              <Typography sx={{ marginTop: "5px" }} variant="subtitle2">
                <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                  Legenda:
                </span>{" "}
                Quando o limiar de algum parâmetro se apresentar como “X → Y”, isso
                significa que seu valor está sendo reconfigurado (de X para Y) no
                momento.
              </Typography>
            </Grid>

          </Grid>
        </AppLayout>
      ) : (
        <AppLayout>
          <Grid container display={'flex'} flexDirection={'column'}>
            {enableSwitch ? (
              <Grid item xl={2} md={3} sm={4} xs={6}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Stack direction="row" sx={{ alignItems: 'center', marginLeft: '10px' }}>
                        <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Granjas</Typography>
                        <Switch
                          sx={{
                            height: "45px",
                            width: "70px",
                            "& .MuiSwitch-switchBase": {
                              margin: 0,
                              padding: 1,
                              transform: "translateX(2px)",
                              "&.Mui-checked": {
                                color: "#fff",
                                transform: "translateX(30px)",
                                "& .MuiSwitch-thumb:before": {},
                                "& + .MuiSwitch-track": {
                                  opacity: 1,
                                  backgroundColor: "#5c7fb8",
                                },
                              },
                            },
                            "& .MuiSwitch-thumb": {
                              backgroundColor: "#21519f",
                              width: 28,
                              height: 28,
                              "&:before": {
                                content: "''",
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                left: 1,
                                top: 0,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                              },
                            },
                            "& .MuiSwitch-track": {
                              opacity: 1,
                              backgroundColor: "#5c7fb8",
                              borderRadius: 20 / 2,
                            },
                          }}
                          onChange={handleChangeSwitch}
                        />
                        <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Veículos</Typography>
                      </Stack>
                    }
                  />
                </FormGroup>
              </Grid>
            ) : (
              <></>
            )}

            <Grid item xl={3} md={3} sm={4} xs={6}>
              <Autocomplete
                id="combo-plates"
                options={platesToSearch}
                sx={{
                  width: "100%",
                  marginBottom: "-50px",
                }}
                onChange={handlePlateSearch}
                renderInput={(params) => (
                  <TextField {...params} label="Pesquisar Granja" />
                )}
                size="small"
              />
            </Grid>

            <Grid item>
              <CrudLayout
                title={<></>}
                formTitle="Cadastro Granja"
                form={<FarmForm />}
                itemToEdit={itemToEdit}
                cleanItemToEdit={handleSetItemToEdit}
                hasNewButton
                onModalClosed={getVehiclesData}
                modalHeight={820}
                children={
                  <DataGridVehicle
                    columns={columnsFarm}
                    editMode="row"
                    data={vehicles.filter((vehicle) => {
                      if (
                        vehicle.typeOperation === "SALA1" ||
                        vehicle.typeOperation === "" ||
                        vehicle.typeOperation === "SALA2" ||
                        vehicle.typeOperation === "SALA3" ||
                        vehicle.typeOperation === "SALA4"
                      ) {
                        return vehicle.plate.includes(selectedPlate);
                      }
                    })}
                    form={<FarmForm />}
                    handleOpenModal={handleOpenModal}
                    onEditOpenModal={true}
                    loadingData={loadingData}
                    updateRecord={handleUpdate}
                    deleteRecord={handleDelete}
                    lockVehicle={lockVehicle}
                    unlockVehicle={unlockVehicle}
                    sendOrNot={paramResponse}
                    type={"farm"}
                  />
                }
              />
            </Grid>

            <Grid item>
              <Typography sx={{ marginTop: "5px" }} variant="subtitle2">
                <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                  Legenda:
                </span>{" "}
                Quando o limiar de algum parâmetro se apresentar como “X → Y”, isso
                significa que seu valor está sendo reconfigurado (de X para Y) no
                momento.
              </Typography>
            </Grid>

          </Grid>
        </AppLayout>
      )}

      <SnackBar open={openSnackBar} side={"left"} action={action} />
    </>
  );
};
